<template>
  <div id="download_i">
    <top></top>
    <div class="main">
      <div class="content">
        <p class="download_i_title">下载邀请函</p>
        <div class="download_i_border"></div>
        <div class="download_i_wrapper">
          <div></div>
        </div>
        <div class="download_i_button">
          <div class="declare_fillButton">下载</div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import top from "../../components/top.vue";
export default {
  name: "downloadInvitation",
  components: { top },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.download_i_title {
  font-size: 18px;
  font-weight: 700;
  color: #333;
}
.download_i_border {
  width: 100%;
  height: 5px;
  background-color: #f3f3f3;
  margin: 20px 0;
}
.download_i_wrapper {
  width: 338px;
  height: 496px;
  background-color: #f5f5f5;
  overflow: hidden;
  > div {
    width: 248px;
    height: 456px;
    margin: 20px auto;
    background-color: red;
  }
}
.download_i_button {
  width: 338px;
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>